import React, { useRef } from 'react';
import { Row } from '@fiverr-private/briefs_table';
import { Button } from '@fiverr-private/button';
import { PrefetchPageLinks, usePrefetchBehavior } from '@fiverr-private/hooks';
import { AppI18n, ExtractAfterDot, TranslationKey } from '../../../../i18n';
import { getAgenticViewPageUrl, getManagementPageUrl } from '../../../shared/const';
import { BriefAction, BriefItem } from '../../../../../lib/types/brief';
import { reportBriefCardClick } from '../../../shared/bqEvents';
import { calculateAction } from './calculateAction';

interface ActionProps {
  row: Row<BriefItem>;
}

const labelByStatus: Record<BriefAction, { labelKey: ExtractAfterDot<TranslationKey> }> = {
  [BriefAction.INVITE_FREELANCERS]: { labelKey: 'actions.invite_freelancers' },
  [BriefAction.VIEW_BRIEF]: { labelKey: 'actions.view_brief' },
  [BriefAction.MANAGE_BRIEF]: { labelKey: 'actions.manage_brief' },
};

export const Action: React.FC<ActionProps> = ({ row }) => {
  const ref = useRef(null);
  const [shouldPrefetch, prefetchHandlers] = usePrefetchBehavior(ref, 'intent');
  const { id: briefId } = row.original;

  const action = calculateAction(row.original);

  const managementPageUrl =
    row.original.type === 'agentic'
      ? getAgenticViewPageUrl(briefId)
      : getManagementPageUrl(briefId, action === BriefAction.INVITE_FREELANCERS ? 'invite' : 'undefined');

  const sendBiEvent = () => {
    const name = `${labelByStatus[action].labelKey.split('.').pop()}_cta`;
    reportBriefCardClick(name, row.original);
  };

  if ([BriefAction.INVITE_FREELANCERS, BriefAction.MANAGE_BRIEF].includes(action)) {
    return (
      <>
        <Button
          href={managementPageUrl}
          size="sm"
          variant="outline"
          target="_blank"
          {...prefetchHandlers}
          ref={ref}
          onClick={sendBiEvent}
        >
          <AppI18n k={labelByStatus[action].labelKey} />
        </Button>
        {shouldPrefetch && <PrefetchPageLinks href={managementPageUrl} />}
      </>
    );
  }

  // BriefAction.VIEW_BRIEF --> No CTAs
  return null;
};
